import { CampaignFragment } from 'src/graphql'

// Campaign Context
export const CAMPAIGN_CONTEXT = 'CAMPAIGN_CONTEXT'
export type CampaignContext = {
  kind: typeof CAMPAIGN_CONTEXT
  campaign: CampaignFragment
  line?: number
}
export const CampaignContext = (
  campaign: CampaignFragment,
  line?: number,
): CampaignContext => ({
  kind: CAMPAIGN_CONTEXT,
  campaign,
  line,
})

// Order Context
const ORDER_CONTEXT = 'ORDER_CONTEXT'
type OrderContext = {
  kind: typeof ORDER_CONTEXT
}
const OrderContext = (): OrderContext => ({
  kind: ORDER_CONTEXT,
})

// No Context
const NO_CONTEXT = 'NO_CONTEXT'
export type NoContext = {
  kind: typeof NO_CONTEXT
}
export const NoContext = (): NoContext => ({ kind: NO_CONTEXT })

export type ContextState = CampaignContext | OrderContext | NoContext
